import {
  BUNDLE_TYPES,
  PACK_NUMBER,
  SIZE_INFO
} from './utils'
import { initi18n } from '../../build_a_box_v2/utils/i18n'

export const emptyState = {
  type: '',
  variants: {},
  wipes: '',
  frequency: 30,
  upsells: [],
  bundle_id: '',
  step: ''
}

export const BAB_TYPES = {
  DIAPERS: 'diapers',
  PANTS: 'pants',
  MIX: 'mix'
}

const iconicUrlBase = () => initi18n().t('shared:iconicUrl')

const SUBSCRIPTION_UPSELL_WIPES = ['L1.IDV', 'L1E.IDV'] // HARDCODED
export const FREQUENCIES = [15, 20, 25, 30, 35, 40, 45]

export function getParams (params) {
  if (params && !params.includes('?withCart')) {
    try {
      return JSON.parse(decodeURIComponent(params)
        .substr(1)
        .replace('params=', ''))
    } catch (error) {
      console.log('error, url is not valid: ', error)
    }
  }
}

export const quantifyItemInTab = (item, tab) => tab.filter(variant => variant.id === item.id).length

export const removeItemFromTab = (item, tab) => {
  let found = false
  const newTab = tab.reduce((acc, variant) => {
    if (!found && item.id === variant.id) {
      found = true
    } else {
      acc = acc.concat([variant])
    }
    return acc
  }, [])

  return newTab
}

export const isMix = box => box.type === 'mix'

export const getBundleFromBox = box => {
  if (!isMix(box)) {
    return box.type
  } else {
    return box.step
  }
}

export const isMixFirstStep = box => isMix(box) && getBundleFromBox(box) === 'pants'

export function isVariantStepValid (urlParams) {
  const allowedSizes = Object.values(SIZE_INFO[urlParams.type]).map(s => s.name)
  const selectedSizesFromURL = Object.keys(urlParams.variants[urlParams.type]).map(s => s)

  return selectedSizesFromURL.every(s => allowedSizes.includes(s))
}

export function controlBagNumber (urlParams) {
  const countSku = Object.entries(urlParams.variants)
    .reduce((acc, [key, value]) => {
      if (key === 'diapers') {
        Object.values(value).forEach((item, index) => {
          acc.diapers += Object.values(value)[index]?.length
        })
      }
      if (key === 'pants') {
        Object.values(value).forEach((item, index) => {
          acc.pants += Object.values(value)[index]?.length
        })
      }
      return acc
    }, { diapers: 0, pants: 0 })

  if (urlParams.type === 'diapers') {
    if (countSku.diapers === PACK_NUMBER.diapers) return true
  }

  if (urlParams.type === 'pants') {
    if (countSku.pants === PACK_NUMBER.pants) return true
  }

  if (urlParams.type === 'mix') {
    const mixPantsNumber = PACK_NUMBER.mix.pants
    const mixDiapersNumber = PACK_NUMBER.mix.diapers
    if (countSku.pants === mixPantsNumber && countSku.diapers === mixDiapersNumber) return true
  }

  return false
}

export function isTypeValid (urlParams) {
  if (!urlParams) return
  return Object.values(BUNDLE_TYPES).some(funnel => funnel === urlParams.type)
}

export function isDeliveryValid (urlParams) {
  return FREQUENCIES.some(freq => freq === urlParams.frequency)
}

export function isUpsellStepValid (urlParams, allowedSkus) {
  return urlParams.upsells.every(sku => allowedSkus && allowedSkus.includes(sku))
}

export function controlVariantsSkus (urlParams, history, allProductsSku) {
  const skuFromURL = Object
    .entries(urlParams.variants[urlParams.type])
    .reduce((acc, [, value]) => acc.concat(value), [])

  const isValid = skuFromURL.map(s => allProductsSku && allProductsSku.some(sku => sku.includes(String(s))))

  if (isValid.includes(false)) {
    emptyState.type = urlParams.type
    emptyState.variants = {}
    return history.push(`${iconicUrlBase()}/size?params=${JSON.stringify(emptyState)}`)
  }
}

export function controlWipes (urlParams) {
  if (urlParams.wipes === 'none' || urlParams.wipes === '') return true
  return SUBSCRIPTION_UPSELL_WIPES.some(sku => sku === urlParams.wipes)
}

function controlBoxKeys (urlParams) {
  const acceptedKeys = Object.keys(emptyState)
  return Object.keys(urlParams).every(k => acceptedKeys.includes(k))
}

export function controlBundleSteps (urlParams = emptyState, history, allowedSkus = [], allProductSku) {
  if (!controlBoxKeys(urlParams)) return history.push(`${iconicUrlBase()}/bundle?params=${JSON.stringify(emptyState)}`)

  const bundleStep = isTypeValid(urlParams)
  if (!bundleStep) return history.push(`${iconicUrlBase()}/bundle?params=${JSON.stringify(emptyState)}`)

  if (!urlParams.variants[urlParams.type]) return

  const variantStep = isVariantStepValid(urlParams)
  if (!variantStep) {
    emptyState.type = urlParams.type
    return history.push(`${iconicUrlBase()}/size?params=${JSON.stringify(emptyState)}`)
  }

  const countBags = controlBagNumber(urlParams)
  if (!countBags) {
    const url = { ...emptyState, type: urlParams.type, variants: {} }
    return history.push(`${iconicUrlBase()}/size?params=${JSON.stringify(url)}`)
  }

  controlVariantsSkus(urlParams, history, allProductSku)

  const deliveryStep = isDeliveryValid(urlParams)
  if (!deliveryStep) {
    const url = { ...emptyState, type: urlParams.type, variants: urlParams.variants, wipes: urlParams.wipes, frequency: 30 }
    return history.push(`${iconicUrlBase()}/delivery?params=${JSON.stringify(url)}`)
  }

  const upsellStep = isUpsellStepValid(urlParams, allowedSkus)

  if (!upsellStep && urlParams.bundle_id.length === 0) {
    return history.push(`${iconicUrlBase()}/upsell?params=${JSON.stringify({ ...urlParams, upsells: [] })}`)
  }
}

export const isMobile = () => window.outerWidth < 768

export function setFullHeightPage (stopScroll = false) {
  const shopifySectionHeaderLegacy = document.getElementById('shopify-section-header')
  if (shopifySectionHeaderLegacy) {
    shopifySectionHeaderLegacy.style.display = 'none'
  }
  const shopifySectionHeaderIDV = document.querySelector('.sticky-header')
  if (shopifySectionHeaderIDV) {
    shopifySectionHeaderIDV.style.display = 'none'
    document.querySelector('body').classList.add('mt-0')
  }
  if (!stopScroll) window.scrollTo(0, 0)
}

export const sendDataLayer = (box, event, upsellPrice) => {
  const totalPrice = Number(box.wipes && box.wipes !== 'none' ? 69.9 : 64.9) + (upsellPrice ? Number(upsellPrice) : 0)
  dataLayer.push({
    event,
    clickData: {
      category: box.type,
      sizeMix: false,
      price: totalPrice.toFixed(2),
      box
    }
  })
}

export const handleNextStep = (box, sizes, setSizes, bundle, isSizeMix, dispatch, updateBox, pantsStep, isEC, isFullMixFlow) => {
  if (isMix(box)) {
    if (isMixFirstStep(box)) setSizes([])

    if (!isEC || isFullMixFlow) {
      const step = pantsStep ? BUNDLE_TYPES.DIAPERS : BUNDLE_TYPES.PANTS
      dispatch(updateBox({ ...box, step, variants: { ...box.variants, [bundle]: { [sizes[0]]: [] } } }))
    } else {
      dispatch(updateBox({ ...box, variants: { ...box.variants, [bundle]: { [sizes[0]]: [] } } }))
    }
  } else {
    const bundleSizesObject = sizes.reduce((acc, size) => {
      if (isSizeMix) {
        return { ...acc, [size]: acc[size] ? [...acc[size], 'none'] : ['none'] }
      } else {
        return { ...acc, [size]: [] }
      }
    }, {})
    dispatch(updateBox({ ...box, variants: { ...box.variants, [bundle]: bundleSizesObject } }))
  }

  !isEC && sendDataLayer(box, 'babStepSize')
}
